const infoCircle = {
  prefix: 'fas',
  iconName: 'info-circle',
  icon: [512, 512, [], '', 'M256 8c136.97 0 248 111.03 248 248S392.97 504 256 504 8 392.97 8 256 119.03 8 256 8Zm31 201.5h-62v186a31 31 0 1 0 62 0v-186ZM256 70a46.5 46.5 0 1 0 0 93 46.5 46.5 0 0 0 0-93Z']
};

export { infoCircle as i };
//# sourceMappingURL=localIcons-889a4ef1-e34c700e.js.map
